import { inject } from "aurelia-framework";
import { DfValueConverter } from "aurelia-i18n";

@inject(DfValueConverter)
export class DateValueConverter {
  private defaultOptions: any = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  };

  constructor(private dfValueConverter: DfValueConverter) {}

  toView(value, options): string {
    return this.dfValueConverter.toView(
      value,
      (<any>Object).assign(this.defaultOptions, options),
    );
  }
}
